<template>
  <div class="personal">
    <Nav :rType="5" @roomid="roomid" :shangchengPay="shangchengPay"></Nav>
    <div style="height: 80px"></div>
    <div class="shangcheng-bottom">
      <div class="personal-bottom-bottom">
        <div>
          <div v-for="(item, index) in list" :key="index">
            <div class="shop_name">{{ item.categoryName }}</div>
            <div class="shop_itemList">
              <div
                class="personal-bottom-bottom-div"
                v-for="(item, index) in item.gifts"
                :key="index"
              >
                <div class="shop_item_img">
                  <img :src="item.iconUrl" alt="" />
                </div>
                <div class="shop_item_right">
                  <div class="title">
                    {{ item.name }}
                  </div>
                  <div class="discript">
                    {{ item.desc }}
                  </div>
                  <div class="moneys">
                    <div class="moneys_left">
                      <span>{{ item.amount }}</span>
                      <span>龙币/{{ item.unit }}</span>
                    </div>
                    <div class="moneys_right">
                      <span @click="goumai(item.id, item.amount)">购买</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 信息提示 -->
    <div v-show="tishi" class="alert_msg">
      <img src="https://oss.ansongqiubo.com/assets/shop/icon_chenggong@2x.png" alt="购买成功" />
      <div style="margin-top: 20px">您已购买成功</div>
    </div>
    <!-- 购买失败 -->
    <div v-show="tishi1" class="alert_msg">
      <img src="https://oss.ansongqiubo.com/assets/shop/icon_shibai@2x.png" alt="购买成功" />
      <div style="margin-top: 20px">购买失败</div>
    </div>
    <!-- 余额不足 -->
    <!-- <div v-show="tishi2" class="alert_msg">
      <img src="https://oss.ansongqiubo.com/assets/shop/icon_jinggao@2x.png" alt="余额不足" />
      <div style="margin-top: 20px">龙币余额不足，请快去充值</div>
    </div> -->

    <mydialog :status='tishi2' dtype="img" desc="龙币余额不足，请快去充值" >
      <template slot="img">
        <div slot="img">
            <img src="https://oss.ansongqiubo.com/assets/shop/icon_shibai@2x.png" alt="" srcset="">
        </div>
      </template>
    </mydialog>
    <!-- 弹框提示 -->
    <mydialog :status='goumaiYincang' @close='quxiaogoumai' @btnok='quedingoumai' title="您确定购买VIP1道具吗？" ></mydialog>
    <!-- <div v-show="goumaiYincang" class="mydialog">
      <div class="dialog_mask"></div>
      <div class="dialog_box">
        <div class="mydialog_content"></div>
        <div class="footer">
          <div class="calcel" @click="quxiaogoumai">
            <div>取消</div>
          </div>
          <div class="btnOk" @click="quedingoumai">
            <div>确认</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import mydialog from '../component/mydialog.vue'
import qs from "qs";
export default {
  name: "App",
  data() {
    return {
      list: [],
      pay: false,
      qrcode_url: "",
      uid: 0, //用户uid
      shangchengPay: "",
      tishi: false,
      tishi1: false,
      tishi2: false,
      goumaiYincang: false,
      shangpinId: null,
      shangpinLongbi: null,
    };
  },
  mounted() {
    this.$axios
      .get(this.api + "/v1/mall/list", {
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
        },
      })
      .then((res) => {
        console.log(res);
        this.list = res.data.data;
      });
    this.roomid();
  },
  methods: {
    roomid(e) {
      this.uid = e;
    },
    quxiaogoumai() {
      this.goumaiYincang = false;
    },
    quedingoumai() {
      console.log(this.shangpinId);
      console.log(this.shangpinLongbi);
      this.$axios
        .get(this.api + "/v1/wallet/info", {
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res);
          if (res.data.data.balance >= this.shangpinLongbi) {
            this.$axios({
              headers: {
                device: "web",
                packageId: "1",
                version: "1.0.0",
                channel: "web",
                "authToken": localStorage.getItem("token"),
                "Content-Type": "application/x-www-form-urlencoded",
              },
              transformRequest: [
                function (data) {
                  //在请求之前对data传参进行格式转换
                  data = qs.stringify(data);
                  return data;
                },
              ],
              url: this.api + "/v1/mall/item",
              method: "post",
              data: {
                giftId: this.shangpinId,
              },
            }).then((res) => {
              console.log(res);
              if (res.data.message == "success") {
                this.goumaiYincang = false;
                this.tishi = true;
                setTimeout(() => {
                  this.tishi = false;
                }, 2000);
              } else {
                this.tishi1 = true;
                setTimeout(() => {
                  this.tishi1 = false;
                }, 2000);
              }
            });
          } else {
            this.goumaiYincang = false;

            //  打开充值窗口

            // 提示不足
            this.tishi2 = true;
            setTimeout(() => {
              this.tishi2 = false;
            }, 2000);

            // this.$axios({
            //   headers: {
            //     device: "web",
            //     packageId: "1",
            //     version: "1.0.0",
            //     channel: "web",
            //     "authToken": localStorage.getItem("token"),
            //     "Content-Type": "application/x-www-form-urlencoded",
            //   },
            //   transformRequest: [
            //     function (data) {
            //       //在请求之前对data传参进行格式转换
            //       data = qs.stringify(data);
            //       console.log(data);
            //       return data;
            //     },
            //   ],
            //   url: "https://pay-gateway.ansongqiubo.com/v1/payment/trade",
            //   method: "post",
            //   data: {
            //     user_id: this.uid,
            //     amount: "5000",
            //     desc: "50000",
            //     method: "ali_adapay_qr",
            //   },
            // }).then((res) => {
            //   console.log(res);
            //   this.shangchengPay = res.data.data.qrcode_url;
            // });
          }
        });
    },
    goumai(e, r) {
      console.log(e);
      console.log(r);
      if (localStorage.getItem("token")) {
        this.shangpinId = e;
        this.shangpinLongbi = r;
        this.goumaiYincang = true;
      } else {
        alert("请先去登陆");
      }
    },
    pays(e) {
      this.pay = e;
    },
  },
  components: {
    Nav,mydialog
  },
};
</script>

<style scoped lang='scss'>
.sanjiao {
  width: 0;
  height: 0;
  border-top: 11px solid #ffffff;
  /* border-bottom-width: 11px; */
  /* border-radius: 0px; */
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  margin: 0 auto;
  margin-top: 15px;
}
.personal {
  width: 100vw;
  height: 100vh;
  background: #f7f8fa;
}
.alert_msg {
  position: absolute;
  top: calc(50% - 142px / 2);
  left: calc(50% - 248px / 2);
  text-align: center;
  height: 142px;
  border-radius: 6px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
  width: 248px;
  img {
    margin-top: 12px;
    width: 60px;
    height: 60px;
  }
}
.mydialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(46, 48, 52, 0.3);
  .dialog_mask {
  }
  .dialog_box {
    box-sizing: border-box;
    width: 286px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 152px;
    background: #ffffff;
    box-shadow: 0px 2px 10px 0px rgba(46, 48, 52, 0.3);
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 24px 38px;
    flex-direction: column;
  }
  .mydialog_content {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    display: flex;
    align-items: center;
    flex: 2;
  }
  .footer {
    display: flex;
    justify-content: space-around;
    width: 100%;
    .calcel {
      width: 68px;
      cursor: pointer;
      height: 30px;
      background: #dadada;
      border-radius: 100px;
      text-align: center;
      line-height: 30px;
    }
    .btnOk {
      cursor: pointer;

      text-align: center;
      line-height: 30px;
      width: 68px;
      height: 30px;
      color: #fff;
      background: rgba(114, 30, 220, 1);
      border-radius: 100px;
    }
  }
}
.shangcheng-bottom {
  /* width: 100vw; */
  height: calc(100% - 100px);
  min-width: 1350px;
  .personal-bottom-bottom {
    width: 1240px;
    background: #ffffff;
    margin: 12px auto 0 auto;
    padding: 24px;
    overflow: hidden;
    .shop_name {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .shop_itemList {
      display: flex;
      flex-flow: row wrap;
      margin-bottom: 24px;
      display: flex;
      .personal-bottom-bottom-div {
        margin-top: 20px;
        cursor: pointer;
        width: 375px;
        height: 112px;
        background: #ffffff;
        border-radius: 6px;
        border: 1px solid #f7f8fa;
        margin-left: 12px;
        display: flex;
        transition: all 0.2s;
      }
      .personal-bottom-bottom-div:hover {
        transition: all 0.2s;
        background: #ffffff;
        box-shadow: 0px 2px 30px 0px rgba(46, 48, 52, 0.3);
        border-radius: 6px;
        border: 1px solid #f7f8fa;
        .moneys_right{
        transform: scale(1.1);

          }
      }
      .shop_item_img {
        width: 160px;
        height: 112px;
        img {
          width: 160px;
          height: 112px;
        }
      }
      .shop_item_right {
        padding: 10px 12px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
        .moneys {
          display: flex;
          justify-content: space-between;
          .moneys_left {
            span {
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ff8729;
            }
          }
          .moneys_right {
            width: 64px;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 20px;
            background: linear-gradient(270deg, #f7b552 0%, #ff8729 100%);
            border-radius: 10px;
            span {
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
            }
          }

        }
        .discript {
          margin-top: 2px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
}
.personal-bottom-top {
  width: 100%;
  height: 60px;
  /* display: flex;
    justify-content: center;
    align-items: center; */
  // background-color: #191919;
}
.personal-bottom-top-div {
  width: 1240px;
  height: 60px;
  margin: 0 auto;
  color: white;
  font-size: 23px;
  line-height: 60px;
  /* background-color: rosybrown; */
  display: flex;
  align-items: center;
}
.personal-bottom-top-div-div {
  width: 6px;
  height: 50px;
  background-color: #721edc;
  border-radius: 6px;
}

.daohang {
  display: flex;
  color: white;
  width: 500px;
  margin-left: 20px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 16px;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
</style>



// WEBPACK FOOTER //
// src/component/Shangcheng.vue